import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import { configurations } from './configurations';

export const initialState = {
  cpdCategorys: [],
  isFetching: false,
  error: null
};

const reducer = handleActions({
  ...mapReducersFromConfigurations('cpdCategorys')(configurations),
  [LOCATION_CHANGE]: (state, action) => {
    return Object.assign({}, state, {
      error: null,
      isFetching: false
    });
  }
}, {
    ...initialState
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/areas-of-advice/reducers.js